module.exports = __webpack_public_path__ + "static/media/Portrait-10193.8993f366.jpg";